export default {
  /**
   * @return {Number} 前回のデータ取得からの経過時間（分） -1: 取得中, -2: 未取得
   */
  timeDiff ({ loading, currentTimestamp, fetchedTimestamp }) {
    if (loading) return -1
    return fetchedTimestamp
      ? Math.round(Math.abs(((currentTimestamp - fetchedTimestamp) / (1000 * 60))))
      : -2
  }
}
